// removed by extract-text-webpack-plugin
module.exports = {"category-edit-modal":"category-edit-modal","modal-body":"modal-body","category-tabs":"category-tabs","button-tab":"button-tab","active":"active","category-tab-content":"category-tab-content","category-tab-item":"category-tab-item","category-info":"category-info","category-preview":"category-preview","button-merge":"button-merge","icon-merge":"icon-merge"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/category-edit-modal/category-edit-modal.style.sass
// module id = udzI
// module chunks = 0